import { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import ImageCard from './Career/ImageCard';
import JobsModal from "./Career/JobsModal.tsx";

const Career = () => {
  const { translations } = useLanguage();
  const [showBraunschweigModal, setShowBraunschweigModal] = useState(false);
  const [showTunisModal, setShowTunisModal] = useState(false);
  const [showDobaiModal, setShowDobaiModal] = useState(false);
  const [showJobModal, setShowJobModal] = useState(false);

  return (
    <div id="career" className="py-5 bg-white">
      <div className="max-w-full mx-auto px-4 sm:px-6 md:px-8">
        {/* Braunschweig Section */}
        <div className="mb-10">
          <h2 className="text-3xl font-light text-gray-900 mb-5">{translations.Karriere_bei_novobit}</h2>
          <div className="grid grid-cols-1  lg:grid-cols-5   gap-3">
            <div className="relative h-100 overflow-hidden rounded-lg col-span">
              <ImageCard
                  imageSrc="../../assets/Pictures/Career_Braunschweig.jpg"
                  hoverImageSrc="../../assets/Pictures/Career_Braunschweig.jpg"
                title="Braunschweig"
                onClick={() => setShowBraunschweigModal(true)}
              />
              <h6 className="absolute top-1 left-2 text-[#d3edfc] text-[20px] "
                  style={{    fontFamily: 'sans-serif'}} >{translations.Braunschweig} </h6>
            </div>
            <div className="relative h-100 overflow-hidden rounded-lg col-span  ">
              <ImageCard
                imageSrc="../../assets/Pictures/Career_Tunis.jpg"
                hoverImageSrc="../../assets/Pictures/Career_Tunis.jpg"
                title="tunis"
                onClick={() => setShowTunisModal(true)}
              />
              <h6 className="absolute top-1 left-2 text-[#d3edfc] text-[20px] "
                  style={{    fontFamily: 'sans-serif'}} >{translations.Tunis} </h6>
            </div>
            <div className="relative h-100 overflow-hidden rounded-lg col-span ">
              <ImageCard
                imageSrc="../../assets/Pictures/Career_Dubai.jpg"
                hoverImageSrc="../../assets/Pictures/Career_Dubai.jpg"
                title="Career_Dubai"
                onClick={() => setShowDobaiModal(true)}
              />
              <h6 className="absolute top-1 left-2 text-[#d3edfc] text-[20px] "
                  style={{    fontFamily: 'sans-serif'}} >{translations.Dubai} </h6>
            </div>
            <div className="relative h-100 overflow-hidden rounded-lg col-span ">
              <ImageCard
                  imageSrc="../../assets/Pictures/Career_Job_Offers.jpg"
                  hoverImageSrc="../../assets/Pictures/Career_Job_Offers.jpg"
                  title="ob_Offers"
                  onClick={() => window.open('/job-offers/all', "_blank") }
              />
              <h6 className="absolute top-1 left-2 text-[#d3edfc] text-[20px] "
                  style={{    fontFamily: 'sans-serif'}} >{translations.Jobangebote} </h6>
            </div>
            <div className="relative h-100 overflow-hidden rounded-lg col-span ">
              <ImageCard
                  imageSrc="../../assets/Pictures/Career_5_Application_Process.jpg"
                  hoverImageSrc="../../assets/Pictures/Career_5_Application_Process.jpg"
                  title="Application_Process"
                  onClick={() => setShowJobModal(true)}

              />
              <h6 className="absolute top-1 left-2  text-[20px] text-[#d3edfc]"
                  style={{    fontFamily: 'sans-serif'}} >{translations.Bewerbungsprozess} </h6>
            </div>
          </div>
        </div>

      </div>


      <JobsModal
          isOpen={showBraunschweigModal}
          onClose={() => setShowBraunschweigModal(false)}
          imageSrc={translations.careeBraunshweig}
           altText="Karriere bei german"
           jobButton="german"
      />
      <JobsModal
          isOpen={showTunisModal}
          onClose={() => setShowTunisModal(false)}
          imageSrc={translations.careeTunis}
           altText="Karriere bei tunis"
           jobButton="tunisie"
      />
      <JobsModal
          isOpen={showDobaiModal}
          onClose={() => setShowDobaiModal(false)}
           imageSrc={translations.careerDubai}
          altText="Karriere bei dubai"
           jobButton="dubai"
      />
        <JobsModal
            isOpen={showJobModal}
            onClose={() => setShowJobModal(false)}
             imageSrc={translations.jobOffers}
            altText="Karriere bei novobit"
            jobButton="all"
         />

    </div>
  );
};

export default Career;
